import React, { Component } from 'react';
import { DESC } from '../../../BaseDataTable';
import { Tooltip } from '@material-ui/core';
import { ArrowUpward, ArrowDownward} from '@material-ui/icons';
import { arrayOf, shape, string, any, func, bool } from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';

export default class PagePathTableHead extends Component {
  static propTypes = {
    headers: arrayOf(shape({
      title: string,
      key: string
    })).isRequired,
    tooltipText: string,
    sortKey: string,
    sortStatus: shape({any}),
    onCellClick: func,
  }

  static defaultProps = {
    tooltipText: 'Sort'
  }

  drawArrowIcon() {
    const { sortKey, sortStatus, tooltipText } = this.props;
    const arrowIcon = sortStatus[sortKey] === '' || 
                      sortStatus[sortKey] === DESC? 
                      <ArrowDownward className={styles.arrowIcon}/> :
                      <ArrowUpward className={styles.arrowIcon}/>;
    return ( 
            <Tooltip className={styles.tooltip} title={tooltipText} placement="top">
              <span>{arrowIcon}</span>
            </Tooltip>
            )
  }

  drawTableHead() {
    const { headers, sortKey, onCellClick } = this.props;
    return headers && headers.map( header => {
      const { title, key, icon } = header;
      const arrowIcon = sortKey === key && this.drawArrowIcon();
      if (title && key) {
        return (
          <div className={classNames(styles.tableCell, styles.tableHeadCell )} onClick={onCellClick(key)} key={key}>
                <div className={styles.titleContainer}>
                  {arrowIcon}
                  <span>{title}</span>
                </div>
              {icon}
          </div>
        )
      }
    })
  }
  render() {
    const tableCell = this.drawTableHead();
    return(
      <div className={styles.tableRow}>
        {tableCell}
      </div>
    )
  }
}
